import { TResponseModel } from "../types/config";
import apiUtil from "./api";
import {
  GetSpecificUserListPreference,
  UpdateUserListPreference,
} from "./api.constant";
import { eResultCode } from "./enum";

const COLUMN_PREFERENCES_KEY_PREFIX = "columnPreferences_";

export const saveColumnPreferences = async (key: string, columns: any[]) => {
  try {
    const preferences = columns.map(({ key, hidden }) => ({
      key,
      hidden: !!hidden,
    }));
    const serializedPreferences = JSON.stringify(preferences);
    const requestPayload = {
      data: {
        listKey: `${COLUMN_PREFERENCES_KEY_PREFIX}${key}`,
        listValue: serializedPreferences,
      },
    };

    await apiUtil.post(UpdateUserListPreference, requestPayload);
    // localStorage.setItem(
    //   `${COLUMN_PREFERENCES_KEY_PREFIX}${key}`,
    //   serializedPreferences
    // );
  } catch (error) {
    console.error("Error saving column preferences to local storage:", error);
  }
};

export const loadColumnPreferences = async (key: string) => {
  // console.log({ key });
  try {
    const requestPayload = {
      data: {
        listKey: `${COLUMN_PREFERENCES_KEY_PREFIX}${key}`,
      },
    };

    const responseData: TResponseModel = await apiUtil.post(
      GetSpecificUserListPreference,
      requestPayload
    );
    const { dataResponse, data } = responseData;
    if (dataResponse.returnCode === eResultCode.SUCCESS) {
      return JSON.parse(data?.listValue);
    }
    // const serializedPreferences = localStorage.getItem(
    //   `${COLUMN_PREFERENCES_KEY_PREFIX}${key}`
    // );
    // if (serializedPreferences === null) {
    //   return null;
    // }
    // return JSON.parse(serializedPreferences);
  } catch (error) {
    console.error(
      "Error loading column preferences from local storage:",
      error
    );
    return null;
  }
};

export const clearColumnPreferences = async (key: string) => {
  try {
    // localStorage.removeItem(`${COLUMN_PREFERENCES_KEY_PREFIX}${key}`);
    const requestPayload = {
      data: {
        listKey: `${COLUMN_PREFERENCES_KEY_PREFIX}${key}`,
        listValue: null,
      },
    };

    await apiUtil.post(UpdateUserListPreference, requestPayload);
  } catch (error) {
    console.error(
      "Error clearing column preferences from local storage:",
      error
    );
  }
};
